/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_insight } from "../../App/actions/insight_v2";
import { create_formula } from "../../App/actions/site_selections";

/*PICTURE*/

/*FUNCTION*/
import generate_uuid from "../../App/validation/generate_uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_SAVE_FORMULA = ({
  auth,
  insight_reducer,
  project,
  set_value_insight,
  create_formula,
  toggle_save_formula,
}) => {
  const on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    set_value_insight({
      key: name,
      value: value,
    });
  };

  const on_create_formula = (event) => {
    event.preventDefault();
    toggle_save_formula();
    const { formula_name, formula_desc } = insight_reducer;
    const {
      provinsi,
      kota,
      kecamatan,
      kelurahan,
      array_formula_insight,
      array_group_insight,
      config_final_score,
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
    } = insight_reducer;
    const { geo_project } = project;
    const body = {
      request_id: generate_uuid(),
      project_id: geo_project?._id,
      provinsi,
      kota,
      kecamatan,
      kelurahan,
      formula_name,
      formula_desc,
      array_formula_insight,
      array_group_insight,
      config_final_score,
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
    };
    create_formula(body);
    set_value_insight({
      key: "formula_name",
      value: "",
    });
    set_value_insight({
      key: "formula_desc",
      value: "",
    });
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { formula_name } = insight_reducer;

  //content
  return (
    <main>
      <form onSubmit={on_create_formula}>
        <p className="text_bold margin_bottom">
          {dict?.["Site Selection Formula Name"]?.[language]}
        </p>
        <input
          type="text"
          className="margin_bottom_extra"
          value={formula_name}
          name="formula_name"
          onChange={on_change}
          placeholder="Tulis nama formula"
          data-mapid="insertFormulaName"
        />
        <section className="text_center">
          <button
            className="button_big background_black"
            type="submit"
            data-mapid="clickSave"
          >
            {dict?.["Save"]?.[language]}
          </button>
        </section>
      </form>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  insight_reducer: state.insight_reducer,
  project: state.project,
});

export default connect(mapStateToProps, {
  set_value_insight,
  create_formula,
})(SS_SAVE_FORMULA);
